import { motion, useInView, useAnimation } from "framer-motion";
import data from "../data.json";
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import { useRef, useEffect,useState } from "react";
import {Modal} from '@mui/material';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const UseModal = ({location, title, description,isOpen,setIsOpen}) =>{
   return (
    <Modal
    disableEnforceFocus
    disableAutoFocus
    open = {isOpen}
    aria-labelledby="experience-modal-title"
    aria-describedby="experience-modal-description"
    sx={{
      display: 'flex',
      p: 1,
      alignItems: 'center',
      justifyContent: 'center'
    }}
    onClose={()=>{setIsOpen(false)}}
  >
    <Box
      sx={{
        position: 'relative',
        width: "65%",
        bgcolor: '#343A46',
        p: 4,
        borderRadius:"3rem",
        backgroundColor:"#1e96fc",
        color:"white"
      }}
    >
      <Typography className="experience-modal-title" variant="div">
        {title}
      </Typography>
      <IconButton
      aria-label="close"
      onClick={()=>{setIsOpen(false)}}
      sx={{
        position: 'absolute',
        right: 16,
        top: 16,
        color:"white",
      }}
    >
      <CloseIcon />
    </IconButton>
      <Typography className="experience-modal-location" variant="div">
        - {location}
      </Typography>
      <Typography className="experience-modal-description" sx={{ pt: 2 }}>
        {description}
      </Typography>
    </Box>
  </Modal>
   );
}


const SingleExperienceBox = ({ location, title, description, i }) => {
    const [isOpen,setIsOpen] = useState(false);
    return (
        <>
        <div style={{ display: "flex",  justifyContent: i % 2 === 0 ? "flex-start" : "flex-end" ,backgroundColor: "#1e96fc", borderRadius: "2rem", width: "20rem"}}>
            <div style={{  display: "flex", justifyContent: "flex-start", paddingLeft: "1rem", paddingRight: "1rem", flexDirection: "column" }}>
                <span style={{ marginBottom: "0.1rem",fontFamily:"serif",fontSize:"20px",paddingTop:"5%" }}>{title}</span>
                <p style={{ fontSize: "13px", marginTop: "0px",fontFamily:"serif" }}> - {location}</p>
                {/* <div style={{ display: "flex",fontSize:"15px",fontFamily:"-moz-initial" }}>
                    <p>{description}</p>
                </div> */}
            </div>
            <div style={{marginTop:"1rem",marginRight:"2rem"}}>
              {isOpen?<VisibilityOffIcon  onClick={()=>{setIsOpen(!isOpen)}}/>:<VisibilityIcon  onClick={()=>{setIsOpen(!isOpen)}} />}
            </div>
            <UseModal location={location} title={title} description={description} setIsOpen={setIsOpen} isOpen = {isOpen}/>
        </div>
       
        </>
    );
}

const SingleTimeLine = ({ experience, i }) => {
    return (
        <TimelineItem>
            <TimelineOppositeContent color="white">
                <span style={{ color: "#B1B9C8" }}>{experience.time}</span>
            </TimelineOppositeContent>
            <TimelineSeparator >
                <TimelineDot   />
                <TimelineConnector />
            </TimelineSeparator >
            <TimelineContent style={{display:"flex",justifyContent:i%2===0?"flex-start":"flex-end"}}>
                <SingleExperienceBox description={experience.description} title={experience.title} location={experience.location} i={i} />
            </TimelineContent>
        </TimelineItem>
    )
}

const FlowChart = ({ experiences }) => {
    return (
        <Timeline position="alternate">
            {experiences.map((exp, i) => {
                return (<SingleTimeLine experience={exp} i={i} />)
            })}
        </Timeline>
    );


}

const Experience = ({ refExperience }) => {
    const ref = useRef(null);
    const isInView = useInView(ref)
    const mainControlls = useAnimation();
    useEffect(() => {
        if (isInView) {
            mainControlls.start("visible")
        }
        else {
            mainControlls.start("hidden")
        }

    }, [isInView,mainControlls])
    return (
        <div className="item" ref={refExperience}>
            <div ref={ref}>

                <motion.div className="projects-motion" variants={{
                    hidden: { opacity: 0, x: 100 },
                    visible: { opacity: 1, x: 0 }
                }}
                    initial="hidden"
                    animate={mainControlls}
                    transition={{ duration: 0.5, delay: 0.1 }}
                    whileHover={{ scale: 1 }}>
                    <div className="item-title">Experience</div>
                    <div className="experience-item">
                        <FlowChart experiences={data.Experiences} />
                    </div>
                </motion.div>
            </div>
        </div>
    )
}

export default Experience;